import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../shared/components/auth/Input';
import ButtonLoader from '../../shared/components/auth/ButtonLoader';
import { Glyphicon } from 'react-bootstrap';
import { updatePassword } from '../../actions/auth';
import { connect } from 'react-redux';

class UpdatePasswordForm extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    inputProps: PropTypes.shape({
      password: PropTypes.object,
      passwordConfirmation: PropTypes.object
    })
  };

  static defaultProps = {
    errors: [],
    isLoading: false,
    inputProps: {
      password: {},
      passwordConfirmation: {}
    }
  };

  state = {
    password: null,
    password_confirmation: null
  }

  handleInput = (key, value) => {
    this.setState({[key]: value});
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const formData = this.state;
    const isUpdated = await this.props.dispatch(updatePassword(formData));

    if (isUpdated) {
      this.setState({
        password: null,
        password_confirmation: null
      });
    }

  }

  getFieldErrors = (fieldName) => {
    const {errors} = this.props;
    return errors.reduce((acc, curr) => {
      if (Array.isArray(curr[fieldName])) {
        return acc.concat(curr[fieldName]);
      }
      return acc;
    }, []);
  }

  render () {
    const {isLoading} = this.props;
    return (
      <form
        className='update-password-form clearfix'
        onSubmit={this.handleSubmit.bind(this)}
      >
        <Input
          type='password'
          label='Password'
          placeholder='Password'
          errors={this.getFieldErrors('password')}
          disabled={isLoading}
          groupClassName='update-password-password'
          value={this.state.password || ''}
          onChange={val => this.handleInput('password', val)}
        />

        <Input
          type='password'
          label='Password Confirmation'
          placeholder='Password Confirmation'
          disabled={isLoading}
          errors={this.getFieldErrors('password_confirmation')}
          groupClassName='update-password-password-confirmation'
          value={this.state.password_confirmation || ''}
          onChange={val => this.handleInput('password_confirmation', val)}
        />

        <ButtonLoader
          loading={isLoading}
          type='submit'
          disabled={isLoading}
          className='pull-right update-password-submit'
          icon={this.props.icon || <Glyphicon glyph='lock'/>}
          onClick={this.handleSubmit}
        >Update Password
        </ButtonLoader>
      </form>
    );
  }
}

export default connect(({auth: {isLoading, errors}}) => ({isLoading, errors}))(UpdatePasswordForm);



// WEBPACK FOOTER //
// ./src/account/components/update-password-form.js